import { IAppState } from '../interface/app.state.interface';

export const selectLoggedInUser = (state: IAppState) => state.user.loggedInUser;
